import { useMutation } from "@tanstack/react-query";
import { useToast } from "#/hooks/ToastContext";
import { requestArticleReviewRevision } from "#/services/articles";

export function useArticleReviewRevision() {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: (articleId: string) => requestArticleReviewRevision(articleId),
    onSuccess: () => {
      showToast("Review submitted for processing.", "success");
    },
    onError: (error) => {
      const message =
        error instanceof Error
          ? error.message
          : "Failed to submit review for processing.";
      showToast(message, "error");
    },
  });
}

export default useArticleReviewRevision;
